module.exports = __webpack_public_path__ + "img/t7.49715ca7.jpg";